import {RegisterOptions} from "react-hook-form/dist/types/validator";
import {EMAIL_REGEXP_ALLOW_WILDCARD, PHONE_REGEX} from "../user/ui/form";
import {matches} from "../user/ui/utils";
import {FormStep, UserAttributeDefinition, UserInput, UserLoginPrincipal, UserPrimaryField} from "../http/protocol";
import {t} from "../i18n";

export const EMAIL_VALIDATION_OPTIONS : RegisterOptions = {
    minLength : 4, maxLength : 200, required : true, pattern : EMAIL_REGEXP_ALLOW_WILDCARD
};
export const PHONE_VALIDATION_OPTIONS : RegisterOptions = {
    pattern : PHONE_REGEX, required : true
}
export const PASSWORD_VALIDATION_OPTIONS : RegisterOptions = {
    minLength : 8, maxLength : 100, required : true, validate : (value:string) => {
        if(!value || value.trim().length == 0) {
            return false;
        }
        let lower = /[a-z]/.test(value);
        let upper = /[A-Z]/.test(value)
        let number = /[0-9]/.test(value);
        let email = matches(value,EMAIL_REGEXP_ALLOW_WILDCARD);

        return lower && upper && number && !email;
    }
};
export const REPEAT_PASSWORD_VALIDATION_OPTIONS : RegisterOptions = {
    minLength : 8, maxLength : 100, required : true, validate : (value:string) => {
        if(!value || value.trim().length == 0) {
            return false;
        }
        let lower = /[a-z]/.test(value);
        let upper = /[A-Z]/.test(value)
        let number = /[0-9]/.test(value);
        let email = matches(value,EMAIL_REGEXP_ALLOW_WILDCARD);

        return lower && upper && number && !email;
    }
};
export const getRepeatedInputName = (name? : string, attribute? : UserAttributeDefinition) => {

    if(attribute?.attributeKey) {
        let key = attribute.attributeKey;
        return "attributes.repeat" + key.substring(0,1).toUpperCase() + key.substring(1);
    } else if(name){
        return "repeat" + name.substring(0,1).toUpperCase() + name.substring(1);
    } else {
        return "";
    }

}

/**
 * Finds the index of form step of the field that is passed
 * @param principal current login principal
 * @param field
 * @param formSteps
 */
export const findStepIndexFromField = (principal : UserLoginPrincipal, field : string, formSteps? : FormStep[]) => {
    let step = -1;
    if(!formSteps) {
        return step;
    }
    if(principal == UserLoginPrincipal.EMAIL && field === UserPrimaryField.email) {
        field = UserPrimaryField.loginPrincipal;
    } else if(principal == UserLoginPrincipal.PHONE_NUMBER && field === UserPrimaryField.phoneNumber) {
        field = UserPrimaryField.loginPrincipal;
    }
    formSteps.forEach((s, stepIndex) => {
        s.groups?.forEach( g => {
            g.inputs?.forEach(i => {
                if(i.field === field) {
                    step = stepIndex;
                } else if((i.userAttributeKey ? "attributes." + i.userAttributeKey : "N/A") == field) {
                    step = stepIndex;
                }
            })
        })
    })
    return step;
}

export const formText = (name : string) => {
    return {
        nameText : t("forms."+name+".label", {}, ""),
        invalidText : t("forms."+name+".invalid"),
        helpText : t("forms."+name+".help",{}, ""),
        placeholder : t("forms."+name+".placeholder", {}, "")
    }
}

export const toSelectOptions = (input : UserInput, attribute? : UserAttributeDefinition) : RegisterOptions => {
    if(!attribute) {
        return {};
    }
    let options : RegisterOptions = {};

    if(input.required === true) {
        options.required = true;
    }
    return options;
}
export const toRegisterOptions = (input : UserInput, attribute? : UserAttributeDefinition) : RegisterOptions => {
    if(!attribute) {
        return {};
    }
    let options : RegisterOptions = {};
    if(attribute.minLength && attribute.minLength > 0) {
        options.minLength = attribute.minLength;
    }
    if(attribute.maxLength && attribute.maxLength > 0) {
        options.maxLength = attribute.maxLength;
    }
    if(attribute.regex && attribute.regex.trim().length > 0) {
        options.pattern = new RegExp(attribute.regex);
    }
    if(input.required === true) {
        options.required = true;
    }
    return options;
}
export const toOptionsArray = (commaSeparatedString : string) => {
    if(!commaSeparatedString || commaSeparatedString.trim().length == 0) {
        return [];
    } else {
        return commaSeparatedString.split(",").map(s => s.trim());
    }
}